(function(){
  var bar = document.getElementById('ydkSticky');
  if(!bar) return;

  function show(){
    bar.classList.add('show');
    bar.setAttribute('aria-hidden','false');
  }

  var reveal = document.querySelector('.ydk-reveal-light');
  if(!reveal) return;

  if('IntersectionObserver' in window){
    var obs = new IntersectionObserver(function(entries){
      if(!entries[0].isIntersecting && entries[0].boundingClientRect.top < 0){
        show();
        obs.disconnect();
      }
    }, {threshold: 0});
    obs.observe(reveal);
  } else {
    function check(){
      if(reveal.getBoundingClientRect().bottom < 0){
        show();
        window.removeEventListener('scroll', check);
      }
    }
    window.addEventListener('scroll', check, {passive: true});
  }
})();
